class FilterButtons {
    constructor($container) {
        this.$filterButtonsContainer = $container;
        
        let dataAttribute = this.getDataAttribute(this.$filterButtonsContainer);
        let containerId = null;
        
        if (!dataAttribute) {
            const $filterButtons = this.$filterButtonsContainer.find('.mad-filter-buttons');
            dataAttribute = this.getDataAttribute($filterButtons);
            
            if (dataAttribute) {
                this.$filterButtonsContainer = $filterButtons;
                containerId = $filterButtons.data(`${dataAttribute}-id`);
            }
        } else {
            containerId = this.$filterButtonsContainer.data(`${dataAttribute}-id`);
        }
        
        this.dataAttribute = dataAttribute;
        this.containerId = containerId;
        
        if (!this.dataAttribute || !this.containerId) {
            //console.warn('FilterButtons: Could not find data attribute or container ID');
            return;
        }
        
        this.$filterButtons = this.$filterButtonsContainer.find('.filter-button, .mad-filter-buttons__link');
        
        this.$contentContainer = jQuery(`.mad-blog-posts__container[data-${this.dataAttribute}-id='${this.containerId}'], 
                                         [data-${this.dataAttribute}-id='${this.containerId}']`).not(this.$filterButtonsContainer);
        
        if (!this.$contentContainer.length) {
            const containerSelectors = [
                `.mad-blog-posts__container[data-${this.dataAttribute}-id='${this.containerId}']`,
                `.mad-pages__container[data-${this.dataAttribute}-id='${this.containerId}']`,
                //`.mad-staff__container[data-${this.dataAttribute}-id='${this.containerId}']`,
                `.mad-${this.dataAttribute}__container[data-${this.dataAttribute}-id='${this.containerId}']`
            ];
            
            for (const selector of containerSelectors) {
                const $container = jQuery(selector);
                if ($container.length) {
                    this.$contentContainer = $container;
                    break;
                }
            }
        }
        
        // Find the item containers within the content container
        if (this.$contentContainer.length) {
            this.$itemContainers = this.$contentContainer.find(this.getItemSelector()) || 
                                  this.$contentContainer.find('.mad-blog-posts__post-container');
            
            if (this.$itemContainers.length && this.$filterButtons.length) {
                this.init();
            } else {
                //console.warn('FilterButtons: Could not find items to filter');
            }
        } else {
            //console.warn(`FilterButtons: Could not find content container with data-${this.dataAttribute}-id="${this.containerId}"`);
        }
    }
    
    // Determine which data attribute is being used on an element
    getDataAttribute($element) {
        const dataAttrs = [
            'posts', 'pages', /*'staff',*/ 'products', 'podcasts', 'events', 'news', 'filter-group', 'filter'
        ];
        
        for (const attr of dataAttrs) {
            if ($element.data(`${attr}-id`) !== undefined) {
                return attr;
            }
        }
        
        return null;
    }
    
    //Get the item selector based on the data attribute
    getItemSelector() {
        const selectors = {
            'posts': '.mad-blog-posts__post-container',
            'pages': '.mad-pages__page-container',
            //'staff': '.mad-staff__member',
            'products': '.mad-product__item',
            'podcasts': '.mad-podcast__item',
            'events': '.mad-event__item',
            'news': '.mad-news__item'
        };
        
        return selectors[this.dataAttribute] || '.filterable-item';
    }
    
    init() {
        // Only attach click events for button elements (not links)
        this.$filterButtons.filter('button').on('click', (event) => {
            event.preventDefault();
            const $button = jQuery(event.currentTarget);
            const filterValue = $button.data('filter');
            
            this.$filterButtons.removeClass('active');
            $button.addClass('active');
            
            this.filterItems(filterValue);
        });
    }
    
    //Filter the items based on the selected filter value
    filterItems(filterValue) {
        if (filterValue === 'all') {
            this.$itemContainers.removeClass('disabled');
        } else {
            this.$itemContainers.addClass('disabled');
            
            this.$itemContainers.filter(function() {
                const $item = jQuery(this);
                let itemData = $item.data('categories') || $item.data('keywords') || $item.data('terms');
                
                if (itemData) {
                    const dataArray = typeof itemData === 'string' ? itemData.split(' ') : itemData;
                    return Array.isArray(dataArray) ? dataArray.includes(filterValue) : false;
                } else {
                    return $item.hasClass(filterValue);
                }
            }).removeClass('disabled');
        }
    }
}

jQuery(document).ready(function() {
    jQuery('.mad-filter-buttons__container, .mad-filter-buttons').each(function() {
        new FilterButtons(jQuery(this));
    });
});